import { render } from "./index.vue?vue&type=template&id=0fe3e624&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0fe3e624&lang=css"
import "./index.vue?vue&type=style&index=1&id=0fe3e624&scoped=true&lang=css"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe3e624"]])

export default __exports__